<div class="user-info-wrapper" [class.row-direction]="row" *ngIf="userData">
  <img src="/assets/temp-acc.png" alt="user-avatar" class="user-avatar" />
  <div class="user-info">
    <div class="user-name">
      {{ userData.firstName }} {{ userData.lastName }}
    </div>
    <div class="user-desc">{{ userData.title }}</div>
  </div>
</div>
